module.exports = __webpack_public_path__ + "static/media/Genesis-Mobile-Banner-@1-411x93.fd18e727.jpg";